(function(algolia) {
  'use strict';
  var rangeSlider = algolia.externals.widgets.rangeSlider;
  var menu = algolia.externals.widgets.menu;
  var refinementList = algolia.externals.widgets.refinementList;
  var translations = algolia.translations;
  var sheetMusicEnhancedFacets = [
    'meta.next_cart.publisher',
    'tags',
    'meta.next_cart.composer',
    'meta.next_cart.editor',
    'meta.next_cart.instrumentation',
    'meta.next_cart.orchestration',
    'meta.next_cart.classification',
    'meta.next_cart.genre',
  ];
  algolia.localFacetSearchAttributes = [];
  algolia.sheetMusicSortableFacetAttributes = sheetMusicEnhancedFacets.slice();
  var isSheetMusicStandalonePage = Boolean(algolia.sheetMusicStandalonePage);

  if (
    isSheetMusicStandalonePage &&
    Array.isArray(algolia.sheetMusicFacets) &&
    algolia.sheetMusicFacets.length > 0
  ) {
    var standaloneSheetMusicFacets = algolia.sheetMusicFacets.filter(function(facet) {
      return facet && facet.name !== 'named_tags_names';
    });

    if (standaloneSheetMusicFacets.length > 0) {
      algolia.sheetMusicFacets = standaloneSheetMusicFacets;
      algolia.config.facets = standaloneSheetMusicFacets;
    }
  }
  var sheetMusicAcronymDescriptions = {
    a: 'A',
    amp: 'Amplified',
    al: 'Alto',
    b: 'B flat',
    band: 'Band',
    bar: 'Baritone',
    bc: 'Keyboard part with optional basso part',
    bon: 'Bongo',
    bs: 'Bass',
    bsn: 'Bassoon',
    btl: 'Bottle',
    bw: 'Boomwhackers',
    c: 'C',
    cd: 'Compact Disc',
    cl: 'Clarinet',
    ctrbs: 'Contrabass',
    clv: 'Clave',
    ctral: 'Contra-alto',
    d: 'D flat',
    dm: 'Drum',
    e: 'E flat',
    elec: 'Electric/Electronics',
    enhn: 'English Horn',
    euph: 'Euphonium',
    f: 'F',
    fif: 'Fife',
    flxens: 'Flexible Ensemble',
    fl: 'Flute in C',
    flug: 'Flugel Horn',
    g: 'G',
    gtr: 'Guitar',
    hb: 'Handbell',
    hj: 'Headjoint',
    hpcd: 'Harpsichord',
    hp: 'Harp',
    hn: 'Horn',
    kyd: 'Keyboard',
    mr: 'Marimba',
    mz: 'Mezzo',
    nafl: 'Native American Flute',
    nar: 'Narrator',
    ob: 'Oboe',
    opt: 'Optional',
    orch: 'Orchestra',
    org: 'Organ',
    panfl: 'Pan Flute',
    pc: 'Piccolo',
    perc: 'Percussion',
    pnwh: 'Pennywhistle',
    pn: 'Piano',
    rec: 'Recorder',
    sax: 'Saxophone',
    sndm: 'Snare Drum',
    sop: 'Soprano',
    stbs: 'String Bass',
    storch: 'String Orchestra',
    tam: 'Tam Tam',
    tamb: 'Tambourine',
    tn: 'Tenor',
    tm: 'Timpani',
    tnwh: 'Tin Whistle',
    tp: 'Pre-recorded Tape',
    tpt: 'Trumpet',
    trm: 'Trombone',
    tb: 'Tuba',
    vb: 'Vibraphone',
    va: 'Viola',
    vn: 'Violin',
    vc: 'Cello',
    vce: 'Voice',
    wst: 'Whistle',
    xyl: 'Xylophone',
  };
  var sheetMusicPitchModifiers = {
    a: true,
    b: true,
    c: true,
    d: true,
    e: true,
    f: true,
    g: true,
  };
  var sheetMusicPrefixModifiers = {
    amp: true,
    opt: true,
    al: true,
    bar: true,
    bs: true,
    ctrbs: true,
    ctral: true,
    mz: true,
    sop: true,
    tn: true,
  };

  var sanitizeAcronymToken = function(token) {
    return token
      .toLowerCase()
      .replace(/^[\[\]()]+/, '')
      .replace(/[\[\]()]+$/, '')
      .replace(/[.,]+$/, '');
  };

  var translateAcronymPhrase = function(phrase) {
    var words = phrase
      .split(/\s+/)
      .map(sanitizeAcronymToken)
      .filter(Boolean);

    if (words.length === 0) {
      return null;
    }

    var translatedParts = [];
    var index = 0;

    while (index < words.length) {
      var token = words[index];
      var nextToken = words[index + 1];
      var tokenLabel = sheetMusicAcronymDescriptions[token];

      if (!tokenLabel) {
        return null;
      }

      if (
        sheetMusicPitchModifiers[token] &&
        nextToken &&
        sheetMusicAcronymDescriptions[nextToken]
      ) {
        translatedParts.push(
          sheetMusicAcronymDescriptions[nextToken] + ' in ' + tokenLabel
        );
        index += 2;
        continue;
      }

      if (
        sheetMusicPrefixModifiers[token] &&
        nextToken &&
        sheetMusicAcronymDescriptions[nextToken]
      ) {
        translatedParts.push(
          tokenLabel + ' ' + sheetMusicAcronymDescriptions[nextToken]
        );
        index += 2;
        continue;
      }

      translatedParts.push(tokenLabel);
      index += 1;
    }

    return translatedParts.join(', ');
  };

  var translateAcronymTerm = function(rawTerm) {
    var term = rawTerm.trim();

    if (!term) {
      return null;
    }

    term = term.replace(/^\[+/, '').replace(/\]+$/, '');

    var quantity = '';
    var body = term;
    var quantityMatch = body.match(/^(\d+(?:-\d+)?)\s+(.+)$/);

    if (quantityMatch) {
      quantity = quantityMatch[1] + ' ';
      body = quantityMatch[2];
    }

    var partSuffix = '';
    var partSuffixMatch = body.match(/^(.+?)(\s+\d+)$/);

    if (partSuffixMatch) {
      body = partSuffixMatch[1];
      partSuffix = partSuffixMatch[2];
    }

    var alternatives = body
      .split('/')
      .map(function(piece) {
        return piece.trim();
      })
      .filter(Boolean);

    if (alternatives.length === 0) {
      return null;
    }

    var translatedAlternatives = alternatives.map(translateAcronymPhrase);

    if (translatedAlternatives.some(function(value) { return value === null; })) {
      return null;
    }

    return quantity + translatedAlternatives.join(' / ') + partSuffix;
  };

  var shouldTranslateAcronymValue = function(value) {
    if (!value || !algolia.sheetMusicMode) {
      return false;
    }

    if (value.indexOf('Sheet Music/') !== -1 || value.indexOf('&') !== -1) {
      return false;
    }

    if (/[A-Z][a-z]{2,}/.test(value)) {
      return false;
    }

    return /[a-z]/.test(value);
  };

  var translateOrchestrationValue = function(rawValue) {
    var value = rawValue.trim();

    if (!shouldTranslateAcronymValue(value)) {
      return null;
    }

    var orchestrationGroups = value.split(';');
    var translatedGroups = [];

    for (var i = 0; i < orchestrationGroups.length; i++) {
      var group = orchestrationGroups[i];
      var groupTerms = group.split(',');
      var translatedTerms = [];

      for (var j = 0; j < groupTerms.length; j++) {
        var translatedTerm = translateAcronymTerm(groupTerms[j]);

        if (!translatedTerm) {
          return null;
        }

        translatedTerms.push(translatedTerm);
      }

      translatedGroups.push(translatedTerms.join(', '));
    }

    return translatedGroups.join('; ');
  };

  var formatSheetMusicTagLabel = function(value) {
    var translatedValue = translateOrchestrationValue(value);
    var rawAcronymValue = value
      .trim()
      .replace(/^\[+/, '')
      .replace(/\]+$/, '');

    if (!translatedValue) {
      return value;
    }

    return translatedValue + ' (' + rawAcronymValue + ')';
  };

  var escapeRegExp = function(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  var instrumentationPhraseToAbbreviation = [
    ['Penny (Tin) Whistle', 'pnwh/tnwh'],
    ['French Horn', 'hn'],
    ['Woodwind Quintet', 'ww quintet'],
    ['Woodwind Quartet', 'ww quartet'],
    ['Woodwind Trio', 'ww trio'],
    ['Flute Choir', 'fl choir'],
    ['Flute Quintet', '5 fl'],
    ['Flute Quartet', '4 fl'],
    ['Flute Trio', '3 fl'],
    ['Flute Duet', '2 fl'],
    ['Alto Flute', 'al fl'],
    ['Bass Flute', 'bs fl'],
    ['Piccolo', 'pc'],
    ['Flute', 'fl'],
    ['Piano', 'pn'],
    ['Guitar', 'gtr'],
    ['Harp', 'hp'],
    ['Organ', 'org'],
    ['Clarinet', 'cl'],
    ['Percussion', 'perc'],
    ['Electronics', 'elec'],
    ['Euphonium', 'euph'],
    ['Violin', 'vn'],
    ['Viola', 'va'],
    ['Cello', 'vc'],
    ['Voice', 'vce'],
    ['Band', 'band'],
    ['Orch', 'orch'],
    ['Orchestra', 'orch'],
    ['Fife', 'fif'],
    ['Recorder', 'rec'],
    ['Audio', 'cd'],
    ['CD', 'cd'],
  ];

  var abbreviateInstrumentationLabel = function(rawValue) {
    var value = (rawValue || '').toString().trim();

    if (!value) {
      return null;
    }

    if (shouldTranslateAcronymValue(value)) {
      return value
        .replace(/^\[+/, '')
        .replace(/\]+$/, '')
        .trim();
    }

    var abbreviation = value;

    abbreviation = abbreviation.replace(/\bFour Flutes\b/gi, '4 fl');
    abbreviation = abbreviation.replace(/\b5\s+or\s+More\s+Flutes\b/gi, '5+ fl');
    abbreviation = abbreviation.replace(
      /\b([0-9]+(?:-[0-9]+)?)\s+Flutes\b/gi,
      '$1 fl'
    );
    abbreviation = abbreviation.replace(/\bFlute Alone\b/gi, 'fl solo');
    abbreviation = abbreviation.replace(/\bSolo Flute\b/gi, 'fl solo');
    abbreviation = abbreviation.replace(/\bPiccolo Alone\b/gi, 'pc solo');

    instrumentationPhraseToAbbreviation.forEach(function(entry) {
      var pattern = new RegExp('\\b' + escapeRegExp(entry[0]) + '\\b', 'gi');
      abbreviation = abbreviation.replace(pattern, entry[1]);
    });

    abbreviation = abbreviation
      .replace(/\s*&\s*/g, ' + ')
      .replace(/\s*\/\s*/g, ' / ')
      .replace(/\s+or\s+/gi, ' / ')
      .replace(/\s*,\s*/g, ', ')
      .replace(/\s+/g, ' ')
      .replace(/\(\s+/g, '(')
      .replace(/\s+\)/g, ')')
      .trim();

    if (!abbreviation || abbreviation.toLowerCase() === value.toLowerCase()) {
      return null;
    }

    return abbreviation;
  };

  var formatSheetMusicInstrumentationLabel = function(value) {
    var instrumentationValue = (value || '').toString().trim();

    if (!instrumentationValue) {
      return value;
    }

    if (shouldTranslateAcronymValue(instrumentationValue)) {
      return formatSheetMusicTagLabel(instrumentationValue);
    }

    var abbreviation = abbreviateInstrumentationLabel(instrumentationValue);

    if (!abbreviation) {
      return instrumentationValue;
    }

    return instrumentationValue + ' (' + abbreviation + ')';
  };

  var TYPES_TO_WIDGET = {
    slider: { name: 'rangeSlider', useDefault: true, widget: rangeSlider },
    menu: { name: 'menu', params: { limit: 10 }, widget: menu },
    conjunctive: {
      name: 'refinementList',
      params: { operator: 'and', limit: 10 },
      widget: refinementList,
    },
    disjunctive: {
      name: 'refinementList',
      params: { operator: 'or', limit: 10 },
      widget: refinementList,
    },
  };

  var sortByRefined = function sortByRefined(sortFunction) {
    return function(a, b) {
      if (a.refined !== b.refined) {
        if (a.refined) {
          return -1;
        }
        if (b.refined) {
          return 1;
        }
      }
      return sortFunction(a, b);
    };
  };

  /*
   * Sorting functions : Allows to chose in which order you want to display the facets
   * Algolia will always send you back the most relevant values for each facet (the ones
   * with the highest count). These sorting functions won't change which results come back
   * but how they are displayed. To retrieve more results, change the maxValuesPerFacet
   * parameter in your Algolia Dashboard.
   * The default sort function is refined > count > name.
   */
  algolia.facetSortFunctions = {
    price_range: sortByRefined(function sortRanges(a, b) {
      if (a.name.length === b.name.length) {
        return a.name.localeCompare(b.name);
      }
      return a.name.length - b.name.length;
    }),
  };

  /*
   * Display functions
   * When the object sent back for a facet item doesn't match how you would want it to look
   * like, use a function to reformat it how you want.
   */
  algolia.facetDisplayFunctions = {
    price_range: function displayRange(value) {
      var values = value.split(':');

      return values
        .map(e => {
          return algolia.formatMoney(Number(e) * 100).replace(/\.\d+/, '');
        })
        .join(' - ');
    },
  };

  algolia.facetCssClasses = {
    root: 'ais-facet',
    header: 'ais-facet--header',
    body: 'ais-facet--body',
    item: 'ais-facet--item',
    label: 'ais-facet--label',
    checkbox: 'ais-facet--checkbox',
    active: 'ais-facet--active',
    count: Boolean(algolia.config.show_products) ? 'ais-facet--count-distinct' : 'ais-facet--count',
  };

  var enabledFacets = algolia.config.facets.filter(facet => {
    return facet.enabled || parseInt(facet.enabled, 10);
  });
  algolia.facets = enabledFacets.map(facet => { 
    const facetTitle = translations?.facets?.find(f => f.name === facet.name);
    const title = facetTitle ? facetTitle.title : facet.title;
    return {
      ...facet,
      title: title,
      escapedName: encodeURIComponent(facet.name),
    }
  });
  algolia.shownFacets = algolia.facets.filter(facet => {
    return facet.type !== 'hidden';
  });
  algolia.hiddenFacets = algolia.config.facets.filter(facet => {
    return facet.type === 'hidden';
  });

  var facetToWidget = function(facet) {
    var widget = TYPES_TO_WIDGET[facet.type];
    var params = algolia.assign({}, widget.params);
    var useLocalFacetSearch =
      Boolean(algolia.sheetMusicMode) &&
      Array.isArray(algolia.localFacetSearchAttributes) &&
      algolia.localFacetSearchAttributes.indexOf(facet.name) !== -1;
    var useSheetMusicExpandedFacetControls =
      Boolean(algolia.sheetMusicMode) &&
      sheetMusicEnhancedFacets.indexOf(facet.name) !== -1;

    params.container =
      "[class~='ais-facet-" + facet.escapedName + "-container']";
    params.attribute = facet.name;
    params.templates = {};
    params.cssClasses = algolia.facetCssClasses;

    /**
     * Providing a custom "Show more" template to confirm to the custom
     */
    params.templates.showMoreText = function showMoreText(data, {html}) {
      return algolia.instantSearchShowMore(data, html)
    }

    if (facet.searchable && !useLocalFacetSearch) {
      params.searchable = true;
      params.searchablePlaceholder = 'Type to search ' + facet.title;
      params.templates.searchableNoResults = '<div> No matching for ' + facet.title + '</div>';
    }

    if (useSheetMusicExpandedFacetControls) {
      params.limit =
        facet.name === 'tags'
          ? 250
          : facet.name === 'meta.next_cart.orchestration'
            ? 200
            : 120;
      params.showMore = true;
      params.showMoreLimit =
        facet.name === 'tags'
          ? 1000
          : facet.name === 'meta.next_cart.orchestration' || facet.name === 'meta.next_cart.composer'
            ? 3000
            : 1500;
    }

    params.templates.header = function() {
      return facet.title;
    };

    if (!widget.useDefault) {
      params.templates.item = (item, {html}) => {
        return algolia.instantSearchFacetItem(item, html)
      }
    }

    if (algolia.facetSortFunctions[facet.name]) {
      params.sortBy = algolia.facetSortFunctions[facet.name];
    }

    var displayFunction = algolia.facetDisplayFunctions[facet.name];
    params.transformItems = function(items) {
      // CNMC_RETIRE_FLUTE_ONE_WIND_FACET_20260723
      var visibleItems = items;
      if (facet.name === 'meta.next_cart.instrumentation') {
        visibleItems = items.filter(
          item => item.value !== 'Flute & 1 Wind'
        );
      }

      return visibleItems.map(item => ({
        ...item,
        type: facet.type,
        label:
          algolia.sheetMusicMode && facet.name === 'tags'
            ? formatSheetMusicTagLabel(item.value)
            : algolia.sheetMusicMode &&
                (facet.name === 'meta.next_cart.instrumentation' ||
                  facet.name === 'meta.next_cart.orchestration')
              // These are separate authoritative metadata fields. Display each
              // stored value verbatim so descriptive instrumentation is not
              // mixed with generated orchestration shorthand (and vice versa).
              ? item.value
            : displayFunction
              ? displayFunction(item.value)
              : item.value
      }));
    }

    return {
      name: widget.name,
      params: params,
      widget: widget.widget,
    };
  };

  // try to fetch facets for current collection or fallback to collections default
  var collection_facets =
    algolia.current_collection_id &&
    algolia.config.collection_facets &&
    algolia.config.collection_facets[algolia.current_collection_id]
      ? algolia.config.collection_facets[algolia.current_collection_id]
      : algolia.config.collection_facets &&
        algolia.config.collection_facets.default;

  var isSheetMusicCollectionPath = Boolean(
    (window.location.pathname || '').match(/\/collections\/sheet-music(?:\/|$)/i)
  );

  if (isSheetMusicCollectionPath) {
    var stripSheetMusicSeriesFacet = function(facets) {
      return (facets || []).filter(function(facet) {
        return facet && facet.name !== 'named_tags_names';
      });
    };

    var fallbackSheetMusicFacets = [
      {
        name: 'meta.next_cart.publisher',
        title: 'Publisher',
        enabled: true,
        type: 'disjunctive',
        searchable: true,
        available_types: ['menu', 'conjunctive', 'disjunctive'],
      },
      {
        name: 'meta.next_cart.composer',
        title: 'Composer',
        enabled: true,
        type: 'disjunctive',
        searchable: true,
        available_types: ['menu', 'conjunctive', 'disjunctive'],
      },
      {
        name: 'meta.next_cart.editor',
        title: 'Editor',
        enabled: true,
        type: 'disjunctive',
        searchable: true,
        available_types: ['menu', 'conjunctive', 'disjunctive'],
      },
      {
        name: 'meta.next_cart.instrumentation',
        title: 'Instrumentation',
        enabled: true,
        type: 'disjunctive',
        searchable: true,
        available_types: ['menu', 'conjunctive', 'disjunctive'],
      },
      {
        name: 'meta.next_cart.orchestration',
        title: 'Orchestration',
        enabled: true,
        type: 'disjunctive',
        searchable: true,
        available_types: ['menu', 'conjunctive', 'disjunctive'],
      },
      {
        name: 'meta.next_cart.classification',
        title: 'Category',
        enabled: true,
        type: 'disjunctive',
        searchable: true,
        available_types: ['menu', 'conjunctive', 'disjunctive'],
      },
      {
        name: 'meta.next_cart.genre',
        title: 'Genre',
        enabled: true,
        type: 'disjunctive',
        searchable: true,
        available_types: ['menu', 'conjunctive', 'disjunctive'],
      },
    ];

    var preferredSheetMusicFacets =
      Array.isArray(algolia.sheetMusicFacets) && algolia.sheetMusicFacets.length > 0
        ? algolia.sheetMusicFacets
        : fallbackSheetMusicFacets;

    var normalizedSheetMusicFacets =
      stripSheetMusicSeriesFacet(preferredSheetMusicFacets);

    collection_facets = normalizedSheetMusicFacets;
    algolia.sheetMusicFacets = normalizedSheetMusicFacets;
    algolia.config.collection_facets = algolia.config.collection_facets || {};

    if (algolia.current_collection_id) {
      algolia.config.collection_facets[
        algolia.current_collection_id
      ] = normalizedSheetMusicFacets;
    }
    algolia.config.collection_facets.default = normalizedSheetMusicFacets;
  }

  if (collection_facets) {
    var enabledCollectionFacets = collection_facets.filter(facet => {
      return facet.enabled || parseInt(facet.enabled, 10);
    });

    algolia.collectionFacets = enabledCollectionFacets.map(facet => ({
      ...facet,
      escapedName: encodeURIComponent(facet.name)
    }));
    algolia.collectionShownFacets = algolia.collectionFacets.filter(facet => {
      return facet.type !== 'hidden';
    });
    algolia.collectionHiddenFacets = collection_facets.filter(facet => {
      return facet.type === 'hidden';
    });
    algolia.collectionFacetsWidgets = algolia.collectionShownFacets.map(facetToWidget);
  }
  algolia.facetsWidgets = algolia.shownFacets.map(facetToWidget);
})(window.algoliaShopify);
